import { Button, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import DialogAlert from "~/components/common/dialog/dialogAlert";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import Utils from "~/helpers/Utils";
import { sendMsgWavy, sendNumber, sendSmsTwilio } from "~/services/loginService";
import { DialogBuilder } from "~/utils/DialogProvider";
import { getFriendlyFirebaseMessage } from "~/utils/treatFirebaseMessages";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import 'react-phone-input-2/lib/style.css';
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import { getCountryCode as getIsoFromPrefix } from "~/helpers/countriesHelper";
import CountryDialCodeSelect from "~/components/common/CountryDialCodeSelect";
import useStyles from "./styles";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { colors } from "~/utils/colors";

function TelephoneComponent(props) {
	const classes = useStyles();
	const location = useLocation();
    const [country, setCountry] = useState("BR");
	const { brand } = colors;
	const { i18n, t } = useTranslation();
	const [ddiIndex, setPhoneDdiIndex] = useState(0);
	const [phone, setPhone] = useState("");
	const [loading, setLoading] = useState(false);
	const [openError, setOpenError] = useState(false);
	const [messageError, setMessageError] = useState("");
	const [titleMessageError, setTitleMessageError] = useState(t("Ocorreu um erro"));
	const [goBackRoute, setGoBackRoute] = useState(props?.location?.state?.goBackRoute ?? null);
	const { goBackRouteProps } = location.state ?? {};
	const { business } = useSelector((store) => store?.business);

	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const language = storageLanguage ?? business?.language;

	const dialog = useContext(DialogBuilder);

	const onClickGoBack = () => {
		props.history.goBack();
	};

	const handleCloseModal = () => {
		setLoading(false);
		setOpenError(false);
	};

	const handleCallSupport = () => {
		const _message = t("msgSupport");
		const _link = `https://wa.me/5516996500540?text=${_message}`;
		window.open(_link, "_blank");
		mixpanelTrackEvent("Falar_com_Suporte", {}, phone, {});
	};


	const firebaseNumbers = [
		"+5516911111113",
		"+5516911111112",
		"+5516911111114",
		"+5516911111115",
		"+5511222222231",
		"+5511123456789",
		"+5511900000009",
		"+5571988888888",
		"+5511933330001",
	];

	const isInvalidPhoneNumber = (phone) => {
		const regex = Utils.ddis[ddiIndex]?.pattern.regex ?? null;
		return !regex.test(phone);
	};

	const nextPage = (validateBy, phoneNumber, sessionInfo) => {
		if (
			!Utils.ddis[ddiIndex].ddi ||
			!phoneNumber ||
			Utils.ddis[ddiIndex].ddi.length === 0 ||
			phoneNumber.length === 0
		) {
			dialog
			.withMessage(t("Existe algo errado com seu telefone, por favor verifique e tente novamente!"))
			.withAction(() => props.history.replace("/login", { goBackRoute, goBackRouteProps }))
			.show();
			return;
		}
		props.history.push("/login/code", {
			phone: phoneNumber,
			ddi: Utils.ddis[ddiIndex].ddi,
			validateBy,
			sessionInfo,
			goBackRoute: goBackRoute ? goBackRoute : business?.name ? goBackRoute : "/reservas",
			goBackRouteProps: goBackRouteProps ? goBackRouteProps : business?.name ? goBackRouteProps : {},
			goBackRouteProps,
		});
	};

	const sendCode = () => {
		const removedMaskValue = phone.replace(/\D/g, "");

		let countryCodeValue;

		const verifyRemovePrefix = Utils.removePrefix(Utils.ddis[ddiIndex], removedMaskValue);
		countryCodeValue = Utils.ddis[ddiIndex].ddi + verifyRemovePrefix;

		let phoneNumber = countryCodeValue;

		setLoading(true);
		if (firebaseNumbers.includes(phoneNumber) || Utils.ddis[ddiIndex].ddi !== "+55") {
			sendNumber(phoneNumber)
				.then((res) => {
					nextPage("firebase", removedMaskValue, res.verificationId);
				})
				.catch((err) => {
					setTitleMessageError(t("firebase.title"));
					const getMessage = getFriendlyFirebaseMessage(err?.response?.data?.message || err?.message);
					setMessageError(t(`firebase.${getMessage}`));
					setOpenError(true);
					setLoading(false);
					mixpanelTrackEvent("Erro_ao_enviar_SMS", {
							"Erro": getMessage,
							"Telefone": phoneNumber,
						}, phone, {});
				});
		} else {
			const typeSms = 'twilio';	
			if (typeSms === 'twilio') {
				sendSmsTwilio(phoneNumber)
					.then((res) => {
						nextPage("twilio", removedMaskValue, null);
					})
					.catch((error) => {
						setMessageError(error?.response?.data?.message);
						setOpenError(true);
						setLoading(false);
					});
			 }
			// todo: Descomentar após resolver wavy
			// sendMsgWavy(phoneNumber)
			// 	.then((res) => {
			// 		nextPage("wavy", removedMaskValue, null);
			// 	})
			// 	.catch((err) => {
			// 		sendSmsTwilio(phoneNumber)
			// 			.then((res) => {
			// 				nextPage("twilio", removedMaskValue, null);
			// 			})
			// 			.catch((error) => {
			// 				setMessageError(error?.response?.data?.message);
			// 				setOpenError(true);
			// 				setLoading(false);
			// 			});
			// 	});
		}
	};

	useEffect(() => {
		const _goBackRoute = Utils.safeLocalGet("goBackRoute");
		_goBackRoute && setGoBackRoute(_goBackRoute);
	}, []);

	useEffect(() => {
		if (business) {
			if (language === "portuguese" || language === "portugal") {
				i18n.changeLanguage("pt-BR");
			} else if (language === "spanish") {
				i18n.changeLanguage("es-ES");
			} else {
				i18n.changeLanguage("en-US");
			}
			setPhoneDdiIndex(Utils.phoneDdiIndex(business?.phone));
		} else {
			const currentLang = i18n.language;
			if (currentLang === 'pt-BR') {
				const brazilIndex = Utils.ddis.findIndex(ddi => ddi.ddi === '+55');
				if (brazilIndex !== -1) {
					setPhoneDdiIndex(brazilIndex);
				}
			} else if (currentLang === 'es-ES') {
				const spainIndex = Utils.ddis.findIndex(ddi => ddi.ddi === '+34');
				if (spainIndex !== -1) {
					setPhoneDdiIndex(spainIndex);
				}
			} else {
				const usaIndex = Utils.ddis.findIndex(ddi => ddi.ddi === '+1');
				if (usaIndex !== -1) {
					setPhoneDdiIndex(usaIndex);
				}
			}
		}
	}, [business, i18n]);

	useEffect(() => {
		const current = Utils.ddis[ddiIndex];
		if (!current) return;
		
		const isoFromPrefix = getIsoFromPrefix(current.prefix);
		if (isoFromPrefix) {
			setCountry(isoFromPrefix.toUpperCase());
		} else {
			const ddiDigits = (current.ddi || '').replace(/\D/g, '');
			const match = getCountries().find((c) => String(getCountryCallingCode(c)) === ddiDigits);
			if (match) {
				setCountry(match.toUpperCase());
			}
		}
	}, [ddiIndex]);

	return (
		<>
			<TitleContainer
				loading={loading}
				handleClick={onClickGoBack}
				headerStyle={{ boxShadow: "none", paddingBottom: "0" }}
				//footer={footer(submitForm)}
			>
				<Grid container direction="column" spacing={3}>
					<Grid item xs={8}>
						<Typography className={classes.title}>
							<strong>{t("Login with Phone")}</strong>
						</Typography>
					</Grid>

					<Grid
						item
						style={{
							display: "inline-block",
							padding: "20,0,0,20",
							width: "100%",
							textAlign: "center",
							paddingBottom: 10,
						}}>
						
                        <div style={{ width: "100%", paddingLeft: "5px", display: "flex", alignItems: "center", gap: 8 }}>
                        <CountryDialCodeSelect
                            valueISO2={country}
                            onChange={({ dialCode, iso2 }) => {
                                setCountry(iso2);
                                const foundIndex = Utils.ddis.findIndex((item) => item.ddi === dialCode);
                                if (foundIndex !== -1) {
                                    setPhoneDdiIndex(foundIndex);
                                    setPhone("");
                                }
                            }}
                            width={"80%"}
                        />
                            <TextField
                                value={phone}
                                onChange={(e) => {
                                    const ev = { target: { value: e.target.value } };
                                    const prefix = Utils.ddis[ddiIndex]?.prefix || Utils.ddis[0]?.prefix || 'BRA';
                                    Utils.telephoneMask(ev, prefix);
                                    setPhone(ev.target.value);
                                }}
                                placeholder={t("Enter your phone")}
                                fullWidth
                                inputProps={{ maxLength: Utils.ddis[ddiIndex]?.pattern?.maxLength || 15 }}
                                style={{ height: '44px' }}
                            />
                        </div>
					</Grid>
				</Grid>
				<div style={{ marginTop: "5vh" }}>
					<Grid item container justify="center">
						<div className={classes.divMessage}>
							<Typography className={classes.message} style={{ fontSize: 15 }}>
								<strong>{t("We will send you a code via SMS to validate your phone number")}</strong>
							</Typography>
						</div>
					</Grid>
					<Grid item style={{ paddingTop: 10, textAlign: "center" }}>
						<Button
							id="send-number"
							type="submit"
							style={{
								backgroundColor: isInvalidPhoneNumber(phone) ? "#dddddd" : brand?.default,
							}}
							disabled={isInvalidPhoneNumber(phone)}
							className={classes.button}
							onClick={() => {
								sendCode();
							}}>
							{t("go")}
						</Button>
					</Grid>
				</div>
				<DialogAlert
					title={titleMessageError}
					onOpen={openError}
					message={messageError}
					onOk={handleCallSupport}
					textOk={t("btnSupport")}
					onCancel={handleCloseModal}
					textCancel={t("btnCancel")}
				/>
				<div id="recaptcha-container"></div>
			</TitleContainer>
			{/* <WhatsAppButton bottom={"30px"} /> */}
		</>
	);
}

export default withRouter(TelephoneComponent);
